/** Compact form dialogs (admin CRUD, confirmations). */
export const compactFormDialogContentClassName =
  "max-h-[calc(100svh-2rem)] w-full max-w-[calc(100%-2rem)] overflow-y-auto sm:max-w-md";

/** Standard single-column forms. */
export const standardFormDialogContentClassName =
  "max-h-[calc(100svh-2rem)] w-full max-w-[calc(100%-2rem)] overflow-y-auto sm:max-w-lg";

/** Medium-width settings and account forms. */
export const mediumFormDialogContentClassName =
  "max-h-[calc(100svh-2rem)] w-full max-w-[calc(100%-2rem)] overflow-y-auto sm:max-w-xl";

/** Wide operational forms. */
export const wideFormDialogContentClassName =
  "max-h-[calc(100svh-2rem)] w-full max-w-[calc(100%-2rem)] overflow-y-auto sm:max-w-2xl";
